import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Aún no hay grupos de modificadores. Crea uno nuevo.',
  fields: {
    name: 'Nombre',
    external_id: 'Ref. de {{integration}}',
    prices: 'Precios',
    available: 'Disponible',
    status: 'Estado',
    statuses: {
      good: 'Bueno',
      bad: 'Malo',
      medium: 'Medio',
    },
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Recogida',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.on_site]: 'Pedidos en mesa',
  },
  labels: {
    visible: 'Visible en menú',
    hidden: 'Todos ocultos',
  },
  buttons: {
    add_modifier: 'Añadir modificador',
    delete_modifier_one: 'Eliminar modificador',
    delete_modifier_other: 'Eliminar modificadores',
    show_modifier_group: 'Mostrar grupo de modificadores',
    close_modifier_group: 'Cerrar grupo de modificadores',
    edit: 'Editar',
    duplicate: 'Duplicar',
    history: 'Historial',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Error al duplicar el grupo de modificadores',
    modifier_group_duplicated_successfully: 'Grupo de modificadores duplicado correctamente',
    failed_to_duplicate_modifier: 'Error al duplicar el modificador',
    modifier_duplicated_successfully: 'Modificador duplicado correctamente',
  },
};
